// extracted by mini-css-extract-plugin
export default {"pdfContainer":"DocumentPreview_pdfContainer__EJ8W8","img":"DocumentPreview_img__ifh5C","buttonContainer":"DocumentPreview_buttonContainer__MDapr"};